import React from 'react'

import { EuiCheckbox, EuiFieldNumber, EuiFlexGroup, EuiFlexItem, EuiFormRow } from '@elastic/eui'

import { FormStack } from './FormStack'
import { InternetFieldUpdate } from './quickCampaignChannelsReducer'
import { InternetChannelDraft } from './quickCampaignModels'

export interface IInternetDeliverySettings {
  idPrefix: string
  internet: InternetChannelDraft
  onChange: (fields: InternetFieldUpdate) => void
}

export const InternetDeliverySettings: React.FC<IInternetDeliverySettings> = ({ idPrefix, internet, onChange }) => (
  <FormStack>
    <EuiFlexGroup gutterSize='m' responsive={false}>
      <EuiFlexItem>
        <EuiFormRow id={`${idPrefix}-frequency`} label='Views per user per week' isInvalid={!(internet.impressionFrequency > 0)}>
          <EuiFieldNumber value={internet.impressionFrequency} step={1} onChange={e => onChange({ impressionFrequency: parseInt(e.target.value) })} isInvalid={!(internet.impressionFrequency > 0)} />
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow id={`${idPrefix}-targetCpm`} label='Target CPM' isInvalid={!(internet.targetCPM > 0)}>
          <EuiFieldNumber prepend='$' value={internet.targetCPM} onChange={e => onChange({ targetCPM: parseInt(e.target.value) })} isInvalid={!(internet.targetCPM > 0)} />
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup gutterSize='m' responsive={false}>
      <EuiFlexItem>
        <EuiFormRow label='Inventory' hasChildLabel={false}>
          <React.Fragment>
            <EuiCheckbox id={`${idPrefix}-targetApp`} label='App' checked={internet.inventorySettings.targetApp} onChange={e => onChange({ inventorySettings: { targetApp: e.target.checked } })} />
            <EuiCheckbox id={`${idPrefix}-targetWeb`} label='Web' checked={internet.inventorySettings.targetWeb} onChange={e => onChange({ inventorySettings: { targetWeb: e.target.checked } })} />
          </React.Fragment>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow label='Devices' hasChildLabel={false}>
          <React.Fragment>
            <EuiCheckbox id={`${idPrefix}-targetPc`} label='PC' checked={internet.deviceSettings.targetPc} onChange={e => onChange({ deviceSettings: { targetPc: e.target.checked } })} />
            <EuiCheckbox id={`${idPrefix}-targetPhone`} label='Phone' checked={internet.deviceSettings.targetPhone} onChange={e => onChange({ deviceSettings: { targetPhone: e.target.checked } })} />
            <EuiCheckbox id={`${idPrefix}-targetTablet`} label='Tablet' checked={internet.deviceSettings.targetTablet} onChange={e => onChange({ deviceSettings: { targetTablet: e.target.checked } })} />
          </React.Fragment>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
  </FormStack>
)
